import {
  ActionIcon,
  Avatar,
  Badge,
  Checkbox,
  Combobox,
  createTheme,
  Divider,
  Drawer,
  Group,
  Indicator,
  InputLabel,
  ModalBody,
  ModalHeader,
  ModalTitle,
  Paper,
  Popover,
  rem,
  Spoiler,
  Switch,
  ThemeIcon,
  Tooltip
} from "@mantine/core";

import "./global.css";

export const theme = createTheme({
  black: "#151921",
  colors: {
    yellow: [
      "#fff7e3",
      "#f8edd3",
      "#edd9ab",
      "#e3c580",
      "#dab35b",
      "#d4a843",
      "#d2a235",
      "#b98d26",
      "#a57d1e",
      "#8f6c10"
    ],
    violet: [
      "#eeecff",
      "#d9d5fe",
      "#afa8f5",
      "#8378ec",
      "#5c4ee5",
      "#4536e1",
      "#3928e1",
      "#2b1cc8",
      "#2418b4",
      "#19139f"
    ],
    gray: [
      "#f8f9fa",
      "#f1f3f5",
      "#e9ecef",
      "#dee2e6",
      "#ced4da",
      "#adb5bd",
      "#868e96",
      "#495057",
      "#343a40",
      "#212529"
    ]
  },
  defaultRadius: 4,
  primaryColor: "violet",
  fontFamily: "Albert Sans, sans-serif",
  primaryShade: 5,
  headings: {
    fontFamily: "Albert Sans, sans-serif",
    fontWeight: "500",
    sizes: {
      h1: {
        fontWeight: "500",
        fontSize: "6rem",
        lineHeight: "1.167"
      },
      h2: {
        fontWeight: "500",
        fontSize: "3.75rem",
        lineHeight: "1.2"
      },
      h3: {
        fontWeight: "500",
        fontSize: "3rem",
        lineHeight: "1.167"
      },
      h4: {
        fontWeight: "500",
        fontSize: "2.125rem",
        lineHeight: "1.235"
      },
      h5: {
        fontWeight: "500",
        fontSize: "1.5rem",
        lineHeight: "1.334"
      },
      h6: {
        fontWeight: "700",
        fontSize: "1.25rem",
        lineHeight: "1.6"
      }
    }
  },
  spacing: {
    lg: rem(24)
  },
  components: {
    ActionIcon: ActionIcon.extend({
      defaultProps: {
        radius: "xl",
        size: "lg",
        variant: "subtle",
        color: "gray"
      }
    }),

    Divider: Divider.extend({
      styles: { root: { alignSelf: "initial" } }
    }),

    ThemeIcon: ThemeIcon.extend({
      defaultProps: {
        variant: "transparent",
        color: "gray",
        fz: 18,
        bd: "0",
        miw: "auto",
        mih: "auto",
        w: "auto",
        lh: "1"
      }
    }),

    Tooltip: Tooltip.extend({
      defaultProps: {
        position: "bottom",
        fz: 12,
        maw: 200
      },
      styles: {
        tooltip: {
          whiteSpace: "normal",
          textAlign: "center"
        }
      }
    }),

    Indicator: Indicator.extend({
      styles: {
        root: {
          zIndex: 190
        }
      }
    }),

    Drawer: Drawer.extend({
      defaultProps: {
        size: 550
      }
    }),

    InputLabel: InputLabel.extend({
      defaultProps: {
        fz: "sm",
        fw: 600,
        mb: rem(2)
      }
    }),

    Popover: Popover.extend({
      defaultProps: {
        floatingStrategy: "fixed"
      }
    }),

    ModalTitle: ModalTitle.extend({
      defaultProps: {
        fw: "bold",
        fz: 16
      }
    }),

    ModalHeader: ModalHeader.extend({
      defaultProps: {
        px: "lg",
        pt: "md",
        pb: "sm"
      }
    }),

    ModalBody: ModalBody.extend({
      defaultProps: {
        px: "lg",
        pb: "md",
        pt: "sm"
      }
    }),

    Group: Group.extend({
      defaultProps: {
        wrap: "nowrap"
      }
    }),

    Combobox: Combobox.extend({
      defaultProps: {
        shadow: "md"
      }
    }),

    Switch: Switch.extend({
      styles: {
        body: {
          alignItems: "center"
        }
      }
    }),

    Spoiler: Spoiler.extend({
      classNames: { root: "spoiler" }
    }),

    Checkbox: Checkbox.extend({
      styles: {
        input: {
          cursor: "pointer"
        }
      }
    }),

    Avatar: Avatar.extend({
      defaultProps: {
        color: "violet"
      }
    }),

    Paper: Paper.extend({
      defaultProps: {
        shadow: "none"
      }
    }),

    Badge: Badge.extend({
      styles: {
        root: {
          flexShrink: 0
        }
      }
    })
  }
});
